export const defaultErrorMessage = "An unexpected error happened.";
export const defaultRetryContactMessage =
  "Please try again and contact us if the problem persists.";
export const fileDownloadErrorMessage =
  "There was a problem downloading the file. Please try again later.";
export const notFoundErrorMessage = "Not found.";
export const unauthorizedErrorMessage = "Unauthorized.";

export const isNotFoundError = (message: string): boolean =>
  message === notFoundErrorMessage ||
  message.includes("matches the given query"); // Django 4.x returns more descriptive 404 messages like "No Asset matches the given query."

export const defaultPostOptions = {
  headers: { "Content-Type": "application/json" },
};
